import { CommonModule } from '@angular/common';
import { Component, computed, forwardRef, input, model, output } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { FlagPipe } from 'src/app/pipes/flags/flag-pipe';
import { SharedModule } from '../shared/shared-module';

@Component({
  selector: 'app-flag-select',
  imports: [SharedModule, FlagPipe],
  templateUrl: './flag-select.html',
  styleUrl: './flag-select.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FlagSelect),
      multi: true
    }
  ]
})
export class FlagSelect {
  options = input<any[]>([]);
  selected = model<any>();
  label = input<string>('');
  optionValue = input<string>('');
  placeholder = input<string>('');
  filter = input<boolean>(true);
  showClear = input<boolean>(true);
  showCountry = input<boolean>(true);
  changed = output<any>();
  disabled = false;

  // Filter on the label, plus country3Code when it's shown
  filterFields = computed(() =>
    this.showCountry() ? `country3Code,${this.label()}` : this.label()
  );

  onChange = (_: any) => { };
  onTouched = () => { };

  writeValue(value: any): void {
    this.selected.set(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // call this when value changes
  handleChange(event: any) {
    this.selected.set(event);
    this.onChange(event);
    this.onTouched();
    this.changed.emit(event);
  }

  getOptionCode(option: any): string {
    return option?.code || option?.countryCode || option?.flagCode || '';
  }

  getOptionName(option: any): string {
    return option?.name || option?.phoneCode || option?.description || '';
  }
}
